'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _dec3, _class3, _class4, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactSlidedown = require('react-slidedown');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _ResolutionLanding = require('./ResolutionLanding.css');

var _ResolutionLanding2 = _interopRequireDefault(_ResolutionLanding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResolutionLandingAccordion = (_dec = (0, _reactCssModules2.default)(_ResolutionLanding2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ResolutionLandingAccordion, _Component);

  function ResolutionLandingAccordion(props) {
    (0, _classCallCheck3.default)(this, ResolutionLandingAccordion);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ResolutionLandingAccordion.__proto__ || (0, _getPrototypeOf2.default)(ResolutionLandingAccordion)).call(this, props));

    _this.state = {
      planId: props.planId
    };
    return _this;
  }

  (0, _createClass3.default)(ResolutionLandingAccordion, [{
    key: 'render',
    value: function render() {
      var proxyInfoImg = require('../../../static/images/' + this.state.planId + '-proxy-voting-information.jpg');

      var accordionConfigs = [{
        title: 'Vote your own shares',
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Prior to the annual meeting, shareholders are sent documents known as proxy statements that include details about the annual meeting, share ownership, board structure, executive compensation, and details on other issues that will be voted on at the annual meeting. You can cast your ballot by mail, internet, or phone.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Mail:'
            ),
            ' If you receive proxy ballots in the mail, follow the instructions on the ballot. The typical process is to either fill out the paper form and mail it back.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Email:'
            ),
            ' To find your ballot in your email, try searching \u201CProxyVote\u201D \u2013 this is the service your brokerage will likely use to send you your ballot. See this example of what the email should look like:'
          ),
          _react2.default.createElement('img', {
            styleName: 'proxy-ballot-mockup-img',
            src: proxyInfoImg,
            alt: 'ProxyVote screenshot'
          }),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Phone:'
            ),
            ' One you have found your ballot in the mail, or email, there is a number you can call that to vote.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Note that companies have the advantage on proxy statements. The company may bury any shareholder resolutions in the back of the document; include only their opinion arguing against the resolution in an \u201COpposition Statement;\u201D or \u201Csummarize\u201D and possibly misrepresent the resolution up front to discourage you from reading it yourself.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Be sure to go to the resolution, read it, and decide for yourself. You can also contact the people who put the resolution on the ballot to learn why they think you should vote for it.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'If you don\u2019t get a ballot for a company you know you own, contact your financial advisor or the company itself about a month before the company\u2019s AGM.'
          )
        )
      }, {
        title: 'Instruct your financial advisor to vote for you',
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'At any time of the year you can instruct your financial advisor to vote on your behalf. Send your advisor a letter that references your accounts and describes how you would like your shares to be voted.'
          ),
          _react2.default.createElement(
            'blockquote',
            { styleName: 'advisor-letter-blockquote' },
            _react2.default.createElement(
              'p',
              null,
              'Dear ',
              _react2.default.createElement(
                'b',
                null,
                '[ADVISOR NAME HERE]'
              ),
              ','
            ),
            _react2.default.createElement(
              'p',
              null,
              'Please send me a list of companies I am directly invested in and a report showing how my shares were voted last year. After I have reviewed these, I will instruct you as how to vote on shareholder resolutions, board directors, CEO pay, and auditors going forward. If there is any question or if my voting instructions are unclear, please vote my shares according to the following guidelines:'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                '[SHAREHOLDER VOTING PREFERENCES HERE]'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Sincerely,',
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'b',
                null,
                '[SHAREHOLDER NAME]'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'PLEASE NOTE:'
            ),
            ' You can make your voting guidelines as simple or complex as you desire. You could simply instruct your advisor to vote against management on every item, or YES on all Environmental, Social, Governance resolutions; or YES on specific issues and NO on others.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Knowing the date of last year\u2019s Annual General Meeting (AGM) can give you an idea of when to expect a proxy statement, or when to expect your financial advisor to be in touch with you.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Proxy statements usually come out six weeks before the AGM. If you haven\u2019t received a proxy by a month before the company\u2019s AGM, contact your advisor or the company itself. If you elected to get it by email you just click on it and you will see that ballot and also all of your other ones as the control numbers are linked under your name.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'If your financial advisor tells you they refuse to vote your shares for you, or that it is not part of the services that you have paid for, consider taking your business elsewhere.'
          )
        )
      }, {
        title: 'Hold your money manager and mutual fund accountable',
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'You can\u2019t control how shares in mutual funds are voted \u2013 when you invest in a mutual fund, you own a share of the fund, but the fund manager owns the underlying assets.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'However, you can pressure mutual fund managers to vote for shareholder resolutions. Most financial managers vote with management which is not necessarily in the best interest of shareholders or the company.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'To help change this, first find out how your mutual funds vote. Consider contacting the financial managers who run the mutual funds you invest in and request their voting record, or their policies on voting shareholder resolutions.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Next, ask them to vote for \u201CEnvironmental, Social, and Governance.\u201D If enough customers make this request, financial companies may begin voting in support of these resolutions that are designed to reduce corporate risk.'
          )
        )
      }, {
        title: 'See the full resolution',
        content: _react2.default.createElement(
          'div',
          null,
          this.state.planId === 'microsoft' ? _react2.default.createElement(_components.MicrosoftResolutionText, null) : null,
          this.state.planId === 'campbell-soup' ? _react2.default.createElement(_components.CampbellSoupResolutionText, null) : null
        )
      }];

      return _react2.default.createElement(
        'div',
        null,
        accordionConfigs.map(function (e, i) {
          return _react2.default.createElement(ResolutionLandingAccordionItem, {
            key: 'res-lan-acc-ite-' + i,
            title: e.title,
            content: e.content
          });
        })
      );
    }
  }]);
  return ResolutionLandingAccordion;
}(_react.Component)) || _class);
var ResolutionLandingAccordionItem = (_dec2 = (0, _reactCssModules2.default)(_ResolutionLanding2.default, { allowMultiple: true }), _dec2(_class2 = function (_Component2) {
  (0, _inherits3.default)(ResolutionLandingAccordionItem, _Component2);

  function ResolutionLandingAccordionItem(props) {
    (0, _classCallCheck3.default)(this, ResolutionLandingAccordionItem);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ResolutionLandingAccordionItem.__proto__ || (0, _getPrototypeOf2.default)(ResolutionLandingAccordionItem)).call(this, props));

    _this2.state = {
      open: false,
      title: props.title || 'error',
      content: props.content || null
    };
    return _this2;
  }

  (0, _createClass3.default)(ResolutionLandingAccordionItem, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'acc-wrap' },
        _react2.default.createElement(
          'div',
          {
            styleName: 'acc-button',
            onClick: function onClick() {
              _this3.setState({ open: !_this3.state.open });
            }
          },
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_components.LinkIcon, { faclass: this.state.open ? 'fa-close' : 'fa-plus', nospace: true }),
            _react2.default.createElement(
              'b',
              null,
              this.state.title
            )
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          this.state.open ? _react2.default.createElement(
            'div',
            { styleName: 'acc-content' },
            _react2.default.createElement(
              'p',
              null,
              this.state.content
            )
          ) : null
        )
      );
    }
  }]);
  return ResolutionLandingAccordionItem;
}(_react.Component)) || _class2);
var ResolutionLanding = (_dec3 = (0, _reactCssModules2.default)(_ResolutionLanding2.default, { allowMultiple: true }), _dec3(_class3 = (_temp = _class4 = function (_Component3) {
  (0, _inherits3.default)(ResolutionLanding, _Component3);

  function ResolutionLanding(props) {
    (0, _classCallCheck3.default)(this, ResolutionLanding);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (ResolutionLanding.__proto__ || (0, _getPrototypeOf2.default)(ResolutionLanding)).call(this, props));

    _this4.state = {
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    };
    return _this4;
  }

  (0, _createClass3.default)(ResolutionLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!this.props.params.planId) {
        this.context.router.push(_config2.default.routes.home);
        return _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var planId = this.props.params.planId;

      var planData = _config2.default.plansSource[planId];

      // kick home if not one of the allowed companies
      // just microsoft and campbell soup for now
      console.log(planId);
      console.log(planId !== 'microsoft' && planId !== 'campbell-soup');
      if (!planData || !planData.proposal_title || planId !== 'microsoft' && planId !== 'campbell-soup') {
        this.context.router.push(_config2.default.routes.home);
        return _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      // const { title, description, url } = this.state
      var title = planData.short_name + ' shareholder resolution';
      var description = 'Vote for our shareholder resolution at ' + planData.short_name;
      var url = _config2.default.domain + _config2.default.routes.resolutionLanding + '/' + planId;

      var climateRiskInvestments = _format2.default.money(planData.screen_results.dff[0] + planData.screen_results.dff[1] + planData.screen_results.fff[0] + planData.screen_results.fff[1], true, true);

      var proposal_number = planData.proposal_title.slice(0, 10);

      var headlineImg = require('../../../static/images/vote-yes-checkmark.png');

      var mobileBannerStyle = this.state.mobileBannerFixed ? 'mobile-fixed' : 'mobile-relative';

      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'hl-wrap' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                { styleName: 'hl' },
                planData.short_name,
                ' is investing billions of employee savings in fossil fuels'
              ),
              _react2.default.createElement('img', {
                src: headlineImg,
                alt: planData.short_name + ' is investing billions of employee savings in fossil fuels',
                styleName: 'hl-img-sm visible-xs'
              }),
              _react2.default.createElement(
                'h2',
                { styleName: 'lede' },
                'Vote your shares to reduce climate risk and safeguard employee financial security'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'If you own even one share of ',
                    planData.short_name,
                    ', you have a voice.'
                  ),
                  ' As a shareholder, you have influence. Most shareholders vote by proxy, which is the ballot containing all matters being put to a vote by the corporation. It includes board directors, CEO pay, as well as shareholder resolutions about environmental, governance, and social issues critical to the company\u2019s business practices.'
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'scroll-link' },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      activeClass: 'active-scroll-link',
                      to: 'section1',
                      spy: true,
                      smooth: true,
                      offset: -70,
                      duration: 500
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Join ',
                      _react2.default.createElement(
                        'i',
                        null,
                        'As You Sow'
                      ),
                      ' by voting YES on ',
                      proposal_number,
                      ' on your ',
                      planData.short_name,
                      ' shareholder ballot.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'hidden-xs' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'This year, you can vote to ask ',
                    planData.short_name,
                    ':  Why is the company saying \u201C',
                    planData.climate_claim,
                    ',\u201D and at the same time directing ',
                    climateRiskInvestments,
                    ' of employee savings into investments with climate risk like fossil fuels and deforestation-risk agribusiness?'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Use the \u201Cvote now\u201D link to support our resolution. You can also submit questions asking the company what they are doing to reduce climate risk in the company 401(k) plan.'
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'scroll-link' },
                    _react2.default.createElement(
                      _reactScroll.Link,
                      {
                        activeClass: 'active-scroll-link',
                        to: 'section1',
                        spy: true,
                        smooth: true,
                        offset: -70,
                        duration: 500
                      },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Vote YES on ',
                        planData.proposal_title,
                        '.'
                      )
                    )
                  ),
                  _react2.default.createElement(ResolutionLandingAccordion, { planId: planId })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links hidden-xs' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-lbl' },
                    'More'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.plans + '/' + planId,
                        title: planData.plan_short_name + ' scorecard',
                        xstrong: true
                      },
                      planData.short_name,
                      ' retirement plan scorecard',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.eduCenter,
                        title: 'Five steps to a sustainable retirement plan',
                        xstrong: true
                      },
                      'Five steps to a sustainable retirement plan',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hl-img-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'petition-widget-wrap' },
                _react2.default.createElement('img', {
                  src: headlineImg,
                  alt: planData.short_name + ' investors: Vote YES on shareholder proposal ' + proposal_number,
                  styleName: 'hl-img hidden-xs'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sticky-widget ' + mobileBannerStyle },
                  _react2.default.createElement('div', { id: 'section1' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sticky-widget-close visible-xs' },
                    _react2.default.createElement(
                      'div',
                      {
                        onClick: function onClick() {
                          //
                          _this5.setState({
                            mobileBannerFixed: false
                          });
                        }
                      },
                      _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-close' })
                    )
                  ),
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'thumbs-up-top-label' },
                    planData.short_name + ' investors: Vote YES on shareholder proposal ' + proposal_number
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'c' },
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'thumbs-up-top-label-2' },
                      'Have your control number?'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'c' },
                    _react2.default.createElement(
                      'button',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.proxyvote,
                          title: 'Vote your proxy now with your control number',
                          primarybutton: true
                        },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'sidebar-button' },
                          'Vote Now',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'hidden-xs' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'c' },
                      _react2.default.createElement(
                        'h3',
                        { styleName: 'thumbs-up-top-label-2' },
                        planData.plan_short_name,
                        ' scorecard'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'c' },
                      _react2.default.createElement(
                        'button',
                        null,
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: _config2.default.routes.plans + '/' + planId,
                            title: 'Scorecard',
                            orangebutton: true,
                            targetBlank: true
                          },
                          _react2.default.createElement(
                            'div',
                            { styleName: 'sidebar-button' },
                            'Scorecard',
                            _react2.default.createElement(_components.LinkIcon, null)
                          )
                        )
                      )
                    ),
                    _react2.default.createElement('br', null)
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'show-more-button',
                title: 'Learn more',
                onClick: function onClick(e) {
                  _this5.setState({ showFullPetition: !_this5.state.showFullPetition });
                }
              },
              'Learn more',
              _react2.default.createElement(_components.LinkIcon, { faclass: this.state.showFullPetition ? 'fa-angle-double-up' : 'fa-angle-double-down' })
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              this.state.showFullPetition ? _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'This year, you can vote to ask ',
                  planData.short_name,
                  ':  Why is the company saying \u201C',
                  planData.climate_claim,
                  ',\u201D and at the same time directing ',
                  climateRiskInvestments,
                  ' of employee savings into fossil fuels and rainforest destruction?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Leverage your power as a shareholder by ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'Voting YES on ',
                    planData.proposal_title,
                    '.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'scroll-link' },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      activeClass: 'active-scroll-link',
                      to: 'section1',
                      spy: true,
                      smooth: true,
                      offset: -70,
                      duration: 500
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Join lorem.'
                    )
                  )
                ),
                _react2.default.createElement(ResolutionLandingAccordion, { planId: planId })
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links visible-xs' },
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-lbl' },
              'More'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.plans + '/' + planId,
                  title: planData.plan_short_name + ' scorecard',
                  xstrong: true
                },
                planData.short_name,
                ' retirement plan scorecard',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.eduCenter,
                  title: 'Five steps to a sustainable retirement plan',
                  xstrong: true
                },
                'Five steps to a sustainable retirement plan',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return ResolutionLanding;
}(_react.Component), _class4.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class3);
exports.default = ResolutionLanding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResolutionLanding/ResolutionLanding.js
// module id = 1496
// module chunks = 0